import React from "react";
import styled from "styled-components";

import PartsWrapper from "./common/partsWrapper";
import BorderedList from "./common/borderedList";
import { colors, breakpoints, breakpointsArray } from "../../../UIGlobals";
import * as UI from "./timerSlidesUI";

const ColorHeader = styled.span`
  color: ${colors().maroon};
`;

const ImageReversed = styled.img`
  max-height: 550px;
  position: absolute;
  bottom: 0;
  @media (${breakpoints().maxM}) {
    max-height: 300px;
    position: relative;
    top: 50px;
  }
`;

const TextWithIcon = ({ data, bigIcon, reversed, textColumnType, parts, activePart }) => {
  const getColorScheme = () => {
    switch (data.bgTheme) {
      case "darkBlue":
        return { color: colors().white, background: colors().darkBlue }
      case "minty":
        return { color: colors().lightBlack, background: colors().minty }
          default:
        return { color: colors().deepGray, background: colors().white };
    }
  };
  const getColumnBgColor = () => {
    switch (data.columnBgTheme) {
      case "darkBlue":
        return colors().darkBlue;
      case "minty":
      default:
        return colors().white;
    }
  };
  const getMainColor = () => {
    switch (data.detailsTheme) {
      case "darkBlue":
        return colors().darkBlue;
      default:
        return colors().maroon;
    }
  };

  return (
    <UI.Container $colorScheme={getColorScheme()} reversed={reversed}>
      <UI.TextColumn reversed={reversed} textColumnType={textColumnType}>
        {data.showParts && <PartsWrapper parts={parts} activePart={activePart} mainColor={getMainColor()} />}
        {data.header && (
          <UI.Header>
            {data.receiver && <ColorHeader>{data.receiver} </ColorHeader>}
            {data.header}
            {data.subheader && <ColorHeader> {data.subheader}</ColorHeader>}
          </UI.Header>
        )}
        {data.italicParagraphs && data.italicParagraphs.map((paragraph, index) => (
          <UI.ItalicParagraph key={index} text={paragraph} />
        ))}
        {data.paragraphs && data.paragraphs.map((paragraph, index) => (
          <UI.Paragraph key={index} text={paragraph} />
        ))}
        {data.elements && <BorderedList elements={data.elements} mainColor={getMainColor()} />}
        {data.counteredElements && <BorderedList elements={data.counteredElements} counter />}
        {data.textColumnIconUrl && <UI.TextColumnIcon src={data.iconBaseUrl + data.textColumnIconUrl} />}
        {data.bottomParagraphs && data.bottomParagraphs.map((paragraph, index) => (
          <UI.Paragraph bottom key={index} text={paragraph} />
        ))}
      </UI.TextColumn>
      {data.iconUrl && window.innerWidth > breakpointsArray.m && (
        <UI.ImageColumn bgColor={getColumnBgColor()} bgIcon={bigIcon}>
          {reversed ? (
            <ImageReversed src={data.iconBaseUrl + data.iconUrl} alt="icon" />
          ) : (
            <UI.Image src={data.iconBaseUrl + data.iconUrl} alt="icon" bigIcon={bigIcon} />
          )}
        </UI.ImageColumn>
      )}
    </UI.Container>
  )
};

export default TextWithIcon;